module.exports = "<div id=\"subscribeStatsChart\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsPages/Mails/SubscribeStatsChart/subscribeStatsChart.html
// module id = 891
// module chunks = 0